import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ValueBox from  '../common/widget/valueBox'
import Row from  '../common/layout/row'
import InfoBox from  '../common/infoBox/infoBox'
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import Button from '../common/button/button';
import ButtonTable from '../common/table/buttonTable';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import ReactExport from 'react-export-excel-fixed-xlsx';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import FormatUtils from '../common/formatUtils/FormatUtils';
import imagemUser from '../assets/images/user.jpg';
import {
	setFiltro, getListaDRE,
} from './dreActions';
import { getLista as getListaEmpresa } from '../empresa/empresaActions';
import { getLista as getListaCentroCusto } from '../centroCusto/centroCustoActions';
import { getLista as getListaFornecedor } from '../fornecedor/fornecedorActions';
import { getLista as getListaAnalitica } from '../analitica/analiticaActions';
import { getLista as getListaFormaPagamento } from '../formaPagamento/formaPagamentoActions';
import { getLista as getListaDestinatario } from '../destinatario/destinatarioActions';

import contentCardBody from '../common/template/contentCardBody';
import LabelAndInputDate from '../common/form/labelAndInputDate';

class Dre extends Component {

	state = {
		pesquisar: '',
		gruposSelecionados: []
	}

	constructor(props) {
		super(props);
    }

    componentDidMount() {
		this.props.getListaDRE();
		this.props.getListaEmpresa();
		this.props.getListaCentroCusto();
		this.props.getListaFornecedor();
		this.props.getListaAnalitica();
		this.props.getListaFormaPagamento();
		this.props.getListaDestinatario();
    }

    render() {

		const listaCompetenciaHeader = [];
		this.props.listaCompetencia.forEach(item => {
			listaCompetenciaHeader.push({
				competencia: item,
				tipo: 'Valor'
			});
			listaCompetenciaHeader.push({
				competencia: item,
				tipo: 'AV %'
			});
		});

		let listaTotalCompetencia = [];
		let totalReceitaGeral = 0;
		let totalDespesaGeral = 0;
		this.props.listaCompetencia.forEach(competencia => {
			let totalReceita = 0;
			this.props.listaAnaliticaReceita.filter(itemAnalitica => itemAnalitica.competencia == competencia).map(itemAnalitica => {
				totalReceita += parseFloat(itemAnalitica.valor);
				totalReceitaGeral += parseFloat(itemAnalitica.valor);
			});

			let totalDespesa = 0;
			this.props.listaAnaliticaDespesa.filter(itemAnalitica => itemAnalitica.competencia == competencia).map(itemAnalitica => {
				totalDespesa += parseFloat(itemAnalitica.valor);
				totalDespesaGeral += parseFloat(itemAnalitica.valor);
			});

			listaTotalCompetencia.push({
				competencia: competencia,
				totalReceita: totalReceita,
				totalDespesa: totalDespesa
			});
		});

		const espaco = '\u00A0';

        return (
			<Content>
				<ContentCard>
					<ContentCardHeader>
						<Row>						
							<LabelAndInputDate
								maxWidth={180}
								label='Período Inicial'
								cols='12 6 4 4'
								value={this.props.filtro.data_inicial}
								onChange={value => {
									this.props.setFiltro({
										...this.props.filtro,
										data_inicial: value
									});
								}} />
							
							<LabelAndInputDate
								maxWidth={180}
								label='Período Final'
								cols='12 6 4 4'
								value={this.props.filtro.data_final}
								onChange={value => {
									this.props.setFiltro({
										...this.props.filtro,
										data_final: value
									});
								}} />

							<Select
								maxWidth={400}
								options={this.props.listaEmpresa}
								label='Empresa'
								cols=' 12 4 4 3'
								placeholder='Selecione'
								multiple
								onChange={values => {
									this.props.setFiltro({
										...this.props.filtro,
										ids_empresa: values.map(item => item.value)
									});
								}} />
							
							<Select
								maxWidth={400}
								options={this.props.listaCentroCusto}
								label='Centro de Custo'
								cols=' 12 4 4 3'
								placeholder='Selecione'
								multiple
								onChange={values => {
									this.props.setFiltro({
										...this.props.filtro,
										ids_centro_custo: values.map(item => item.value)
									});
								}} />
								
							<Select
								maxWidth={400}
								options={this.props.listaFornecedor}
								label='Fornecedor'
								cols=' 12 4 4 3'
								placeholder='Selecione'
								multiple
								onChange={values => {
									this.props.setFiltro({
										...this.props.filtro,
										ids_fornecedor: values.map(item => item.value)
									});
								}} />
							
							<Select
								maxWidth={400}
								options={this.props.listaAnalitica}
								label='Analítica'
								cols=' 12 4 4 3'
								placeholder='Selecione'
								multiple
								onChange={values => {
									this.props.setFiltro({
										...this.props.filtro,
										ids_analitica: values.map(item => item.value)
									});
								}} />
							
							<Select
								maxWidth={400}
								options={this.props.listaFormaPagamento}
								label='Forma de Pagamento'
								cols=' 12 4 4 3'
								placeholder='Selecione'
								multiple
								onChange={values => {
									this.props.setFiltro({
										...this.props.filtro,
										ids_forma_pagamento: values.map(item => item.value)
									});
								}} />
							
							<Select
								maxWidth={400}
								options={this.props.listaDestinatario}
								label='Origem / Destino'
								cols=' 12 4 4 3'
								placeholder='Selecione'
								multiple
								onChange={values => {
									this.props.setFiltro({
										...this.props.filtro,
										ids_destinatario: values.map(item => item.value)
									});
								}} />
							
							<a class='btn btn-app bg-primary'
								style={{ marginTop: 8 }}
								onClick={() => {
									this.props.getListaDRE();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>
						</Row>
					</ContentCardHeader>
					<ContentCardBody>

						<Table responsive border>
							<THead>
								<Tr>
									<Th alignLeft  width={500}></Th>
									{this.props.listaCompetencia.map(competencia => (
										<Th key={competencia} colspan={2} width={100} alignCenter>{this.formatarCompetencia(competencia)}</Th>
									))}
									<Th colspan={2} width={100} alignCenter>Total</Th>
								</Tr>
								<Tr>
									<Th alignLeft></Th>
									{listaCompetenciaHeader.map(item => (
										<Th key={`${item.competencia}-${item.tipo}`} alignRight>{item.tipo}</Th>
									))}
									<Th alignRight>Valor</Th>
									<Th alignRight>AV %</Th>
								</Tr>
							</THead>
							<TBody>

								<Tr>
									<Td alignLeft bold fontSize={16}>(=) RESULTADO</Td>
									{listaCompetenciaHeader.map(item => {

										const total = listaTotalCompetencia.filter(totalCompetencia => totalCompetencia.competencia == item.competencia)[0].totalReceita
											- listaTotalCompetencia.filter(totalCompetencia => totalCompetencia.competencia == item.competencia)[0].totalDespesa;

										return (
											<Td key={`${item.competencia}-${item.tipo}`} alignRight bold fontSize={16}>
												{item.tipo == 'Valor' ? `R$${espaco}${FormatUtils.formatarValorTela(total, 2)}` : ``}
											</Td>
										);
									})}
									<Td alignRight bold fontSize={16}>{`R$${espaco}${FormatUtils.formatarValorTela(totalReceitaGeral - totalDespesaGeral, 2)}`}</Td>
									<Td alignRight bold fontSize={16}></Td>
								</Tr>

								<Tr>
									<Td alignLeft bold>(+) TOTAL RECEITAS</Td>
									{listaCompetenciaHeader.map(item => {

										const total = listaTotalCompetencia.filter(totalCompetencia => totalCompetencia.competencia == item.competencia)[0].totalReceita;

										return (
											<Td key={`${item.competencia}-${item.tipo}`} alignRight bold>
												{item.tipo == 'Valor' ? `R$${espaco}${FormatUtils.formatarValorTela(total, 2)}` : `${FormatUtils.formatarValorTela(100, 2)}%`}
											</Td>
										);
									})}
									<Td alignRight bold>{`R$${espaco}${FormatUtils.formatarValorTela(totalReceitaGeral, 2)}`}</Td>
									<Td alignRight bold>100,00%</Td>
								</Tr>

								{this.props.listaGrupo.filter(grupo => grupo.tipo == 'receita').map(grupo => {

									let listaAnalitica = [];
									this.props.listaAnaliticaReceita.filter(itemAnalitica => itemAnalitica.id_grupo == grupo.id).forEach(itemAnalitica => {
										if (!listaAnalitica.filter(analitica => analitica.id == itemAnalitica.id_analitica).length) {
											listaAnalitica.push({
												id: itemAnalitica.id_analitica,
												nome: itemAnalitica.nome_analitica
											});
										}
									});

									let totalGrupo = 0;

									return (
										<>
											<Tr key={`grupo-${grupo.id}`}>
												<Td alignLeft paddingLeft={12}>
													<a href='#' 
														style={{
															color: 'inherit',
															textDecoration: 'none',
															cursor: 'pointer' 
														}}
														onClick={event => {
															event.preventDefault();

															let gruposSelecionados = this.state.gruposSelecionados.map(idGrupo => idGrupo);
															if (gruposSelecionados.includes(grupo.id)) {
																gruposSelecionados = gruposSelecionados.filter(idGrupo => idGrupo != grupo.id);
															} else {
																gruposSelecionados.push(grupo.id);
															}

															this.setState({
																gruposSelecionados: gruposSelecionados
															});
														}}>
														(+) {grupo.nome}
														<i class={this.state.gruposSelecionados.includes(grupo.id) ? 'fas fa-chevron-up' : 'fas fa-chevron-down'}
															style={{ marginLeft: 4 }} >
														</i>
													</a>
												</Td>
												{listaCompetenciaHeader.map(item => {

													let valorGrupo = 0;
													this.props.listaAnaliticaReceita.filter(itemAnalitica => itemAnalitica.competencia == item.competencia && itemAnalitica.id_grupo == grupo.id).forEach(itemAnalitica => {
														valorGrupo += parseFloat(itemAnalitica.valor);
													});

													const total = listaTotalCompetencia.filter(totalCompetencia => totalCompetencia.competencia == item.competencia)[0].totalReceita;

													let percentual = total > 0 && valorGrupo > 0 ? (valorGrupo * 100) / total : 0;

													if (item.tipo == 'Valor') {
														totalGrupo += valorGrupo;
													}

													return (
														<Td key={`${item.competencia}-${item.tipo}`} alignRight>
															{item.tipo == 'Valor' ? `R$${espaco}${FormatUtils.formatarValorTela(valorGrupo, 2)}` : `${FormatUtils.formatarValorTela(percentual, 2)}%`}
														</Td>
													);
												})}
												<Td alignRight>{`R$${espaco}${FormatUtils.formatarValorTela(totalGrupo, 2)}`}</Td>
												<Td alignRight>
													{`${FormatUtils.formatarValorTela((totalGrupo > 0 && totalReceitaGeral > 0 ? (totalGrupo * 100) / totalReceitaGeral : 0), 2)}%`}
												</Td>
											</Tr>

											{(this.state.gruposSelecionados.includes(grupo.id) ? listaAnalitica : []).map(analitica => {

												
												let totalAnalitica = 0;
												let totalGrupo = 0;

												return (
													<Tr key={`analitica-${analitica.id}`}>
														<Td alignLeft paddingLeft={22} fontSize={12} bold italic>(+) {analitica.nome}</Td>
														{listaCompetenciaHeader.map(item => {

															let valorGrupo = 0;
															this.props.listaAnaliticaReceita.filter(itemAnalitica => itemAnalitica.competencia == item.competencia && itemAnalitica.id_grupo == grupo.id).forEach(itemAnalitica => {
																valorGrupo += parseFloat(itemAnalitica.valor);
															});

															const valorAnalitica = parseFloat((this.props.listaAnaliticaReceita.filter(itemAnalitica => itemAnalitica.competencia == item.competencia && itemAnalitica.id_analitica == analitica.id)[0] || {}).valor || 0);

															let percentual = valorGrupo > 0 && valorAnalitica > 0 ? (valorAnalitica * 100) / valorGrupo : 0;

															if (item.tipo == 'Valor') {
																totalAnalitica += valorAnalitica;
																totalGrupo += valorGrupo;
															}

															return (
																<Td key={`${item.competencia}-${item.tipo}`} alignRight fontSize={12} bold italic>
																	{item.tipo == 'Valor' ? `R$${espaco}${FormatUtils.formatarValorTela(valorAnalitica, 2)}` : `${FormatUtils.formatarValorTela(percentual, 2)}%`}
																</Td>
															);
														})}
														<Td alignRight fontSize={12} bold italic>{`R$${espaco}${FormatUtils.formatarValorTela(totalAnalitica, 2)}`}</Td>
														<Td alignRight fontSize={12} bold italic>
															{`${FormatUtils.formatarValorTela((totalAnalitica > 0 && totalGrupo > 0 ? (totalAnalitica * 100) / totalGrupo : 0), 2)}%`}
														</Td>
													</Tr>
												);
											})}
										</>
									);
								})}

								<Tr>
									<Td alignLeft bold>(-) TOTAL DESPESAS</Td>
									{listaCompetenciaHeader.map(item => {

										const total = listaTotalCompetencia.filter(totalCompetencia => totalCompetencia.competencia == item.competencia)[0].totalDespesa;

										return (
											<Td key={`${item.competencia}-${item.tipo}`} alignRight bold>
												{item.tipo == 'Valor' ? `R$${espaco}${FormatUtils.formatarValorTela(total, 2)}` : `${FormatUtils.formatarValorTela(100, 2)}%`}
											</Td>
										);
									})}
									<Td alignRight bold>{`R$${espaco}${FormatUtils.formatarValorTela(totalDespesaGeral, 2)}`}</Td>
									<Td alignRight bold>100,00%</Td>
								</Tr>

								{this.props.listaGrupo.filter(grupo => grupo.tipo == 'despesa').map(grupo => {
													
									let listaAnalitica = [];
									this.props.listaAnaliticaDespesa.filter(itemAnalitica => itemAnalitica.id_grupo == grupo.id).forEach(itemAnalitica => {
										if (!listaAnalitica.filter(analitica => analitica.id == itemAnalitica.id_analitica).length) {
											listaAnalitica.push({
												id: itemAnalitica.id_analitica,
												nome: itemAnalitica.nome_analitica
											});
										}
									});

									let totalGrupo = 0;

									return (
										<>
											<Tr key={`grupo-${grupo.id}`}>
												<Td alignLeft paddingLeft={12}>
													<a href='#' 
														style={{
															color: 'inherit',
															textDecoration: 'none',
															cursor: 'pointer' 
														}}
														onClick={event => {
															event.preventDefault();

															let gruposSelecionados = this.state.gruposSelecionados.map(idGrupo => idGrupo);
															if (gruposSelecionados.includes(grupo.id)) {
																gruposSelecionados = gruposSelecionados.filter(idGrupo => idGrupo != grupo.id);
															} else {
																gruposSelecionados.push(grupo.id);
															}

															this.setState({
																gruposSelecionados: gruposSelecionados
															});
														}}>
														(-) {grupo.nome}
														<i class={this.state.gruposSelecionados.includes(grupo.id) ? 'fas fa-chevron-up' : 'fas fa-chevron-down'}
															style={{ marginLeft: 4 }} >
														</i>
													</a>
												</Td>
												{listaCompetenciaHeader.map(item => {

													let valorGrupo = 0;
													this.props.listaAnaliticaDespesa.filter(itemAnalitica => itemAnalitica.competencia == item.competencia && itemAnalitica.id_grupo == grupo.id).forEach(itemAnalitica => {
														valorGrupo += parseFloat(itemAnalitica.valor);
													});

													const total = listaTotalCompetencia.filter(totalCompetencia => totalCompetencia.competencia == item.competencia)[0].totalDespesa;

													let percentual = total > 0 && valorGrupo > 0 ? (valorGrupo * 100) / total : 0;

													if (item.tipo == 'Valor') {
														totalGrupo += valorGrupo;
													}

													return (
														<Td key={`${item.competencia}-${item.tipo}`} alignRight>
															{item.tipo == 'Valor' ? `R$${espaco}${FormatUtils.formatarValorTela(valorGrupo, 2)}` : `${FormatUtils.formatarValorTela(percentual, 2)}%`}
														</Td>
													);
												})}
												<Td alignRight>{`R$${espaco}${FormatUtils.formatarValorTela(totalGrupo, 2)}`}</Td>
												<Td alignRight>
													{`${FormatUtils.formatarValorTela((totalGrupo > 0 && totalDespesaGeral > 0 ? (totalGrupo * 100) / totalDespesaGeral : 0), 2)}%`}
												</Td>
											</Tr>

											{(this.state.gruposSelecionados.includes(grupo.id) ? listaAnalitica : []).map(analitica => {

												let totalAnalitica = 0;
												let totalGrupo = 0;

												return (
													<Tr key={`analitica-${analitica.id}`}>
														<Td alignLeft paddingLeft={22} fontSize={12} bold italic>(-) {analitica.nome}</Td>
														{listaCompetenciaHeader.map(item => {

															let valorGrupo = 0;
															this.props.listaAnaliticaDespesa.filter(itemAnalitica => itemAnalitica.competencia == item.competencia && itemAnalitica.id_grupo == grupo.id).forEach(itemAnalitica => {
																valorGrupo += parseFloat(itemAnalitica.valor);
															});

															const valorAnalitica = parseFloat((this.props.listaAnaliticaDespesa.filter(itemAnalitica => itemAnalitica.competencia == item.competencia && itemAnalitica.id_analitica == analitica.id)[0] || {}).valor || 0);

															let percentual = valorGrupo > 0 && valorAnalitica > 0 ? (valorAnalitica * 100) / valorGrupo : 0;

															if (item.tipo == 'Valor') {
																totalAnalitica += valorAnalitica;
																totalGrupo += valorGrupo;
															}

															return (
																<Td key={`${item.competencia}-${item.tipo}`} alignRight fontSize={12} bold italic>
																	{item.tipo == 'Valor' ? `R$${espaco}${FormatUtils.formatarValorTela(valorAnalitica, 2)}` : `${FormatUtils.formatarValorTela(percentual, 2)}%`}
																</Td>
															);
														})}
														<Td alignRight fontSize={12} bold italic>{`R$${espaco}${FormatUtils.formatarValorTela(totalAnalitica, 2)}`}</Td>
														<Td alignRight fontSize={12} bold italic>
															{`${FormatUtils.formatarValorTela((totalAnalitica > 0 && totalGrupo > 0 ? (totalAnalitica * 100) / totalGrupo : 0), 2)}%`}
														</Td>
													</Tr>
												);
											})}
										</>
									);
								})}								
							</TBody>
						</Table>

						

					</ContentCardBody>
				</ContentCard>
			</Content>
        )
	}
	
	formatarCompetencia(competencia) {
		const ano = competencia.split('/')[0];
		const mes = parseInt(competencia.split('/')[1]) - 1;
		
		const meses = [
			'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
		]

		return `${meses[mes]} de ${ano}`;
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	aguardando: state.dre.aguardando,
	filtro: state.dre.filtro,
	listaAnaliticaReceita: state.dre.listaAnaliticaReceita,
	listaAnaliticaDespesa: state.dre.listaAnaliticaDespesa,
	listaCompetencia: state.dre.listaCompetencia,
	listaGrupo: state.dre.listaGrupo,
	listaEmpresa: state.empresa.listaSelect,
	listaCentroCusto: state.centroCusto.listaSelect,
	listaFornecedor: state.fornecedor.listaSelect,
	listaAnalitica: state.analitica.listaSelect,
	listaFormaPagamento: state.formaPagamento.listaSelect,
	listaDestinatario: state.destinatario.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setFiltro, getListaDRE,
	getListaEmpresa, getListaCentroCusto, getListaFornecedor, getListaAnalitica, getListaFormaPagamento, getListaDestinatario
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Dre)
